import { render, staticRenderFns } from "./ReferralBanner.vue?vue&type=template&id=5983195b&scoped=true&"
import script from "./ReferralBanner.vue?vue&type=script&lang=js&"
export * from "./ReferralBanner.vue?vue&type=script&lang=js&"
import style0 from "./ReferralBanner.vue?vue&type=style&index=0&id=5983195b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5983195b",
  null
  
)

export default component.exports